import { httpClient } from "utils";

export const postMissingDocuments = (missingDocumentsRequest: any) =>
  httpClient.post<any>('/aggregations/missing', missingDocumentsRequest);